import { render, staticRenderFns } from "./BookScreen.vue?vue&type=template&id=37473692&scoped=true&"
import script from "./BookScreen.vue?vue&type=script&lang=js&"
export * from "./BookScreen.vue?vue&type=script&lang=js&"
import style0 from "./BookScreen.vue?vue&type=style&index=0&id=37473692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37473692",
  null
  
)

export default component.exports